import { useApiQuery } from '../useApiQuery';
import { membershipKeys } from '@/lib/queryKeys';
import { membershipEndpoints } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api';
import type { Membership, MembershipListResponse } from '@/types/membership';

export function useMemberships(params: Record<string, unknown> = {}) {
  return useApiQuery<MembershipListResponse>({
    queryKey: membershipKeys.list(params),
    queryFn: async () => {
      const raw = await apiGet<MembershipListResponse | Membership[]>(
        operationsClient,
        membershipEndpoints.list(),
        { params },
      );
      // Handle both { data: [] } and direct array response shapes.
      const items = Array.isArray(raw) ? raw : raw.data;
      return {
        data: items,
        total: Number(Array.isArray(raw) ? items.length : (raw.total ?? items.length)),
        page: Number(Array.isArray(raw) ? 1 : (raw.page ?? params.page ?? 1)),
        limit: Number(Array.isArray(raw) ? items.length : (raw.limit ?? params.limit ?? 25)),
      };
    },
    showErrorToast: false,
  });
}
